let abortController = null
let requestSeq = 0

const buildParticipantsFilterUrl = (form, { resetPage = true } = {}) => {
  const action = form.getAttribute("action") || window.location.pathname
  const url = new URL(action, window.location.origin)
  const params = new URLSearchParams(new FormData(form))
  if (resetPage) params.delete("page")
  url.search = params.toString()
  return url
}

const syncPillChrome = (currentPill, nextPill, { triggerSelector, clearSelector }) => {
  if (!currentPill || !nextPill) return

  currentPill.classList.toggle("is-active", nextPill.classList.contains("is-active"))

  const currentTrigger = currentPill.querySelector(triggerSelector)
  const nextTrigger = nextPill.querySelector(triggerSelector)
  if (currentTrigger && nextTrigger) {
    currentTrigger.textContent = nextTrigger.textContent.trim()
  }

  const currentClear = currentPill.querySelector(clearSelector)
  const nextClear = nextPill.querySelector(clearSelector)
  if (currentClear && !nextClear) {
    currentClear.remove()
  } else if (!currentClear && nextClear && currentTrigger) {
    currentTrigger.insertAdjacentElement("afterend", nextClear.cloneNode(true))
  } else if (currentClear && nextClear) {
    currentClear.replaceWith(nextClear.cloneNode(true))
  }
}

const syncFilterChrome = (root, nextRoot) => {
  root.querySelectorAll("[data-participants-status-filter]").forEach((current) => {
    const param = current.dataset.participantsStatusParam
    const next = nextRoot.querySelector(
      `[data-participants-status-filter][data-participants-status-param="${param}"]`
    )
    if (!next) return

    syncPillChrome(
      current.querySelector(".backoffice-participants-inscription-filter__pill"),
      next.querySelector(".backoffice-participants-inscription-filter__pill"),
      {
        triggerSelector: "[data-participants-status-filter-trigger]",
        clearSelector: ".backoffice-participants-inscription-filter__clear"
      }
    )
  })

  const currentCatalogue = root.querySelector("[data-participants-catalogue-filter]")
  const nextCatalogue = nextRoot.querySelector("[data-participants-catalogue-filter]")
  if (currentCatalogue && nextCatalogue) {
    syncPillChrome(
      currentCatalogue.querySelector(".backoffice-participants-catalogue-filter__pill"),
      nextCatalogue.querySelector(".backoffice-participants-catalogue-filter__pill"),
      {
        triggerSelector: "[data-participants-catalogue-filter-trigger]",
        clearSelector: ".backoffice-participants-catalogue-filter__clear"
      }
    )
  }

  const currentReset = root.querySelector(".backoffice-participants-filters-reset")
  const nextReset = nextRoot.querySelector(".backoffice-participants-filters-reset")
  if (currentReset && nextReset) {
    currentReset.classList.toggle("is-active", nextReset.classList.contains("is-active"))
    const href = nextReset.getAttribute("href")
    if (href) currentReset.setAttribute("href", href)
  }
}

const applyParticipantsLiveResults = (nextDocument) => {
  const root = document.querySelector("[data-participants-live-list]")
  const nextRoot = nextDocument.querySelector("[data-participants-live-list]")
  if (!root || !nextRoot) return false

  const currentMeta = root.querySelector(".backoffice-participants-meta")
  const nextMeta = nextRoot.querySelector(".backoffice-participants-meta")
  if (currentMeta && nextMeta) currentMeta.replaceWith(nextMeta)

  const currentCard = root.querySelector(".backoffice-card.backoffice-card--flush")
  const nextCard = nextRoot.querySelector(".backoffice-card.backoffice-card--flush")
  if (currentCard && nextCard) currentCard.replaceWith(nextCard)

  syncFilterChrome(root, nextRoot)
  return true
}

const rebindParticipantsResults = async () => {
  const [
    { initBackofficeParticipantsBulk },
    { initBackofficeParticipantsPerPage },
    { initBackofficeHeaderMore },
    { initBackofficePendingActions }
  ] = await Promise.all([
    import("packs/init-backoffice-participants-bulk"),
    import("packs/init-backoffice-participants-per-page"),
    import("packs/init-backoffice-header-more"),
    import("packs/init-backoffice-pending-actions")
  ])

  initBackofficeParticipantsBulk()
  initBackofficeParticipantsPerPage()
  initBackofficeHeaderMore()
  initBackofficePendingActions()
  document.dispatchEvent(new CustomEvent("backoffice:participants-results-refreshed"))
}

const refreshParticipantsLive = async (form) => {
  if (!form) return false
  if (!document.querySelector("[data-participants-live-list]")) {
    if (typeof form.requestSubmit === "function") form.requestSubmit()
    else form.submit()
    return false
  }

  const url = buildParticipantsFilterUrl(form)
  const seq = ++requestSeq
  abortController?.abort()
  abortController = new AbortController()

  try {
    const response = await fetch(url.toString(), {
      headers: { Accept: "text/html", "X-Requested-With": "XMLHttpRequest" },
      credentials: "same-origin",
      cache: "no-store",
      signal: abortController.signal
    })
    if (!response.ok || seq !== requestSeq) return false

    const nextDocument = new DOMParser().parseFromString(await response.text(), "text/html")
    if (seq !== requestSeq) return false
    if (!applyParticipantsLiveResults(nextDocument)) return false

    const next = `${url.pathname}${url.search}${window.location.hash}`
    window.history.replaceState(window.history.state, "", next)
    await rebindParticipantsResults()
    return true
  } catch (error) {
    if (error?.name === "AbortError") return false
    if (typeof form.requestSubmit === "function") form.requestSubmit()
    else form.submit()
    return false
  }
}

export {
  buildParticipantsFilterUrl,
  applyParticipantsLiveResults,
  rebindParticipantsResults,
  refreshParticipantsLive
}
